import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [accessDeniedMessage, setAccessDeniedMessage] = useState('');
  
  // Check if user was redirected here due to access denied
  useEffect(() => {
    if (location.state?.error) {
      setAccessDeniedMessage(location.state.error);
      // Clear the state after showing the message
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);
  
  return (
    <div>
      <h2>Dashboard</h2>
      
      {/* Access Denied Alert */}
      {accessDeniedMessage && (
        <div className="row mt-3">
          <div className="col-12">
            <div className="alert alert-warning alert-dismissible fade show" role="alert">
              <i className="bi bi-exclamation-triangle me-2"></i>
              {accessDeniedMessage}
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => setAccessDeniedMessage('')}
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      )}
      
      <div className="row mt-4">
        <div className="col-md-6 col-lg-4 mb-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Summary</h5>
              <p className="card-text">Overview of your portfolio and performance metrics.</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 mb-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Recent Activity</h5>
              <p className="card-text">Latest transactions and account activity.</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 mb-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Alerts</h5>
              <p className="card-text">Important notifications and alerts.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
